// src/pages/Home.jsx
import React from "react";
import { useNavigate, Link } from "react-router-dom";

/* ================= CATEGORY IMAGES ================= */
const categoryImages = {
  supplements: "/assets/wellness.jpeg",
  beauty: "/assets/222.jpeg",
  lifestyle: "/assets/333.jpeg",
  books: "/assets/444.jpeg",
};

/* ================= CATEGORY INFO ================= */
const categoryInfo = {
  supplements: {
    title: "Supplements",
    description:
      "Carefully selected supplements that support hormone balance, energy, and wellness.",
  },
  beauty: {
    title: "Beauty & Wellness",
    description:
      "Curated beauty and wellness products for glowing skin, hair, and overall self-care.",
  },
  lifestyle: {
    title: "Lifestyle",
    description:
      "Daily habits and tools to support healthy routines and balanced living.",
  },
  books: {
    title: "Books & Guides",
    description:
      "Educational resources to understand hormones, lifestyle balance, and wellness.",
  },
};

export default function Home() {
  const navigate = useNavigate();

  /* ================= CATEGORY BOXES ================= */
  const categoryBoxes = Object.keys(categoryInfo).map((key) => (
    <Link
      key={key}
      to={`/category/${key}`}
      className="relative rounded-2xl overflow-hidden w-full sm:w-1/2 md:w-1/4 group hover:scale-105 transition transform"
    >
      <img
        src={categoryImages[key]}
        alt={categoryInfo[key].title}
        className="w-full h-48 object-cover rounded-2xl"
      />
      <div className="absolute inset-0 bg-black/30 flex items-center justify-center rounded-2xl opacity-0 group-hover:opacity-100 transition">
        <h3 className="text-white font-bold text-lg text-center px-2">
          {categoryInfo[key].title}
        </h3>
      </div>
    </Link>
  ));

  return (
    <div>
      {/* ================= HERO ================= */}
      <section className="bg-gradient-to-br from-pink-50 via-white to-purple-50 py-20 md:py-24 px-4 sm:px-6 text-center">
        <h1
          className="text-3xl sm:text-4xl md:text-6xl font-extrabold text-gray-800 leading-tight"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Glow Picks for Women
          <br className="hidden sm:block" />
          <span className="text-pink-500">Beauty • Wellness • Lifestyle</span>
        </h1>

        <p className="mt-4 sm:mt-6 max-w-2xl mx-auto text-gray-600 text-base sm:text-lg md:text-xl">
          Discover hand-picked Amazon favorites for women who want to feel confident,
          energized, and glowing — from beauty and self-care essentials to wellness,
          fitness, and everyday lifestyle must-haves.
        </p>

        <div className="mt-8 sm:mt-10 flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
          <a
            href="#categories"
            className="px-7 py-3 bg-pink-500 text-white rounded-full font-semibold text-base hover:bg-pink-600 transition"
          >
            Shop Glow Picks ✨
          </a>

          <a
            href="https://amzn.to/4bayZW2"
            className="px-7 py-3 border border-pink-300 text-pink-600 rounded-full font-semibold text-base hover:bg-pink-50 transition"
          >
            Trending Amazon Finds →
          </a>
        </div>
      </section>

      {/* ================= ALL PRODUCTS / CATEGORIES ================= */}
      <section id="categories" className="max-w-7xl mx-auto px-6 py-12 font-sans">
        <h2 className="text-3xl font-extrabold text-gray-800 mb-8 text-center">
          Explore by Category
        </h2>

        <div className="flex flex-wrap gap-6 justify-center">
          {categoryBoxes}
        </div>
      </section>
    </div>
  );
}
